import React from 'react';
import UserView from '../../components/user/Profile/UserView';

export const UserPage = () => {

    return (
        <UserView />
    )
}